"use client";

import { useState } from "react";
import LINE from "../images/line.webp";
import LINE2 from "../images/line-2.png";
import LINE3 from "../images/line-3.png";
import { Image, Container, Row, Col } from "react-bootstrap";
import Footer from "../components/footer";


const DailySales = () => {


    return (
        <Container className="relative isolate mt-5 pt-5">
            <h3 className="uppercase text-title text-main mb-5">
                Daily Sales Notification
            </h3>
            <Row className="mb-10">
                <Col xxl={3} xl={3} lg={3} md={6} sm={6} className="d-flex justify-content-center mt-3">
                    <Image
                        src={LINE3}
                        alt="Line Image"
                        width={260}
                        height={'100%'}
                        className="object-contain "
                    />
                </Col>
                <Col xxl={3} xl={3} lg={3} md={6} sm={6} className="d-flex justify-content-center mt-3">
                    <Image
                        src={LINE2}
                        alt="Line Image"
                        width={260}
                        height={'100%'}
                        className="object-contain"
                    />
                </Col>

                <Col xxl={6} xl={6} lg={6} md={12} className="basis-full md:basis-2/2 font-mono text-white py-3 px-5 flex flex-col justify-center">
                    <h3 className='text-xl f-main mb-3'> <span className='text-main'>Background <span className='text-slate-100'>&</span> Problem</span></h3>
                    <p className="font-mono text-jobs mt-1 mb-3">The client required a weekly sales report that must be shared daily via a LINE group. The system needed to:</p>

                    <p className="text-sm sm text-dec mt-1"> ▹ Segment sales data by Business Unit (BU) and by teams</p>
                    <p className="text-sm sm text-dec mt-1"> ▹ Reflect the structure within each BU, which includes: MKT VP, Sales Manager, Top Sale, Sales representatives</p>
                    <p className="text-sm sm text-dec mt-1"> ▹ Display sales data for: Weekly performance, Monthly performance, Overall cumulative totals</p>

                    <p className="font-mono text-jobs mt-1 mb-3">Some BUs include both Pre-Sale and Ready-to-Move-in projects, while others include only one type. This results in inconsistent data structures across BUs.</p>
                    <p className="font-mono text-jobs mt-1 mb-3">Moreover, LINE Flex Message has strict size limitations, making it difficult to include all required data in a single message.</p>
                </Col>
            </Row>





            <Row className="mb-10">
                <h3 className='text-xl font-bold mb-3'> <span className='text-main'>Solution <span className='text-white'>&</span> Implementation</span></h3>

                <Col className="py-3 px-5 flex flex-col justify-center" xxl={6}>
                    <h4 className='text-lg f-main text-white mb-3'>Fetching Data from SQL Server to Google Sheets</h4>
                    <p className="text-sm text-dec mt-1"> ▹ Used Google Apps Script to extract data from the SQL Server and store it in Google Sheets.</p>
                    <p className="text-sm text-dec  mt-1"> ▹ Structured the data into separate sheets based on roles: MKT VP, Sales Manager, Top Sale, Sales representatives</p>
                </Col>

                <Col className="py-3 px-5 flex flex-col justify-center" xxl={6}>
                    <h4 className='text-lg f-main text-white mb-3'>Designing Data Delivery via LINE</h4>
                    <p className="text-sm text-dec mt-1">▹ Utilized the LINE Messaging API to deliver daily sales reports.</p>
                    <p className="text-sm text-dec mt-1">▹ Implemented Flex Message with Carousel layout to systematically separate sales data for each BU.</p>
                </Col>

                <Col className="py-3 px-5 flex flex-col justify-center" xxl={6}>
                    <h4 className='text-lg f-main text-white mb-3'>Designing the Flex Message Structure</h4>
                    <p className="text-sm text-dec mt-1"> ▹ Designed the UI of the Flex Message in Figma to help the client visualize the layout before development.</p>
                    <p className="text-sm text-dec  mt-1"> ▹ Created separate bubbles for each role to manage content limits: 1 bubble for MKT VP, 1 bubble for Sales Manager, 1 bubble for Top Sale, 1 bubble for Sales representatives</p>
                    <p className="text-sm text-dec  mt-1"> ▹ This separation ensured all necessary data could be delivered without exceeding the Flex Message limitations.</p>
                </Col>

                <Col className="py-3 px-5 flex flex-col justify-center" xxl={6}>
                    <h4 className='text-lg f-main text-white mb-3'>Automating Data Retrieval and Report Delivery</h4>
                    <p className="text-sm text-dec mt-1">▹ Developed an Apps Script to fetch updated data from Google Sheets and format it appropriately.</p>
                    <p className="text-sm text-dec mt-1">▹ Set up daily triggers to automatically: Retrieve new data, Send the Flex Message to the designated LINE group</p>
                </Col>
            </Row>



            <Row className="mb-10">
                <Col xxl={8} xl={8} lg={6} md={12} className="basis-full md:basis-2/2 font-mono text-white py-3 px-5 flex flex-col justify-center">
                    <h3 className='text-xl f-main text-white mb-3'> <span className='text-main'>Challenges <span className='text-slate-100'>&</span> Solutions</span></h3>
                    <p className="font-mono text-jobs mt-1 mb-3">Some BUs contain both Pre-Sale and Ready-to-Move-in projects, which resulted in excessively large Flex Messages that exceeded the size limit.</p>
                    <h4 className='text-lg f-main text-white mb-3'>Solution: Dynamic Data Filtering</h4>
                    <p className="text-sm sm text-dec mt-1"> ▹ The system was designed to check the target types (sales or transfer goals) available in each BU before generating the message.</p>
                    <p className="text-sm sm text-dec mt-1"> ▹ If any target type had a value of 0, the system excluded that data type from the Flex Message.</p>
                    <h4 className='text-lg f-main text-white mb-3 mt-3'>Example Scenario:</h4>
                    <p className="text-sm sm text-dec mt-1"> ▹ BU 1 includes both Pre-Sale and Ready-to-Move-in projects.</p>
                    <p className="text-sm sm text-dec mt-1"> ▹ However, some teams within BU 1 may be involved with only one type.</p>
                    <p className="text-sm sm text-dec mt-1"> ▹ Pre-Sale projects only have sales targets (no transfer goals).</p>
                    <p className="text-sm sm text-dec mt-1"> ▹ Ready-to-Move-in projects have both sales and transfer targets.</p>
                    <p className="text-sm sm text-dec mt-1"> ▹ By filtering the data early in the process, the system was able to reduce the size of each Flex Message without sacrificing important information.</p>
                </Col>

                <Col xxl={4} xl={4} lg={6} md={12} className="d-flex justify-content-center">
                    <Image
                        src={LINE}
                        alt="Line Image"
                        width={350}
                        height={'100%'}
                        className="object-contain"
                    />
                </Col>
            </Row>


            <Row className="mb-5">

                <Col className="py-3 px-5 flex flex-col justify-center" xxl={6}>
                    <h3 className='text-xl font-bold mb-3'> <span className='text-main'>Results <span className='text-white'>&</span> & Takeaways</span></h3>
                    <p className="text-sm text-dec mt-1"> ▹ The system successfully automated daily sales report delivery via LINE</p>
                    <p className="text-sm text-dec  mt-1"> ▹ Flex Messages were designed to adapt to varying BU structures and team compositions</p>
                    <p className="text-sm text-dec  mt-1"> ▹ The system reduced message size issues by filtering out unnecessary data</p>
                    <p className="text-sm text-dec  mt-1"> ▹ Users received clear and relevant information tailored to their team’s goals</p>
                </Col>

                <Col className="py-3 px-5 flex flex-col justify-center" xxl={6}>
                    <h3 className='text-xl font-bold mb-3 text-main'>Key Learnings from This Project</h3>
                    <p className="text-sm text-dec mt-1">▹ Designing Flex Messages to support complex and dynamic data structures</p>
                    <p className="text-sm text-dec mt-1">▹ Using Google Apps Script to integrate Google Sheets with SQL Server</p>
                    <p className="text-sm text-dec mt-1">▹ Implementing effective data filtering strategies to manage message size limitations</p>
                </Col>
            </Row>

            <p className="font-mono text-jobs mt-1 mb-3 mb-5">This project enabled the sales teams to track performance in a structured and automated way,
                reduced time spent on manual data collection,
                and contributed to more accurate and timely business decision-making.</p>

            <Col className="mb-10">
                <a href="https://www.figma.com/proto/uPvVXYEgtZ2fJeW1ab0pnu/Flex-Messages?node-id=1-2"
                    target="_blank"
                    rel="noopener noreferrer"
                    className=" px-5 py-3 border text-main custom-rounded text-center w-max" >
                    View Project
                </a>
            </Col>
            <Footer />

        </Container>
    );
}
export default DailySales